<template>
  <v-row>
    <v-col>
      <v-row>
        <v-col class="text-center">
          <span :style="`color: ${screen.text1.color};font-size: ${screen.text1.size}px`">
            Введите количество
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            v-model="anyAmount"
            hide-details
            solo
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="(digit, idx) in [1,2,3,4,5,6,7,8,9]"
          :key="idx"
          cols="4"
          class="d-flex justify-center"
        >
          <v-btn
            :style="`color: ${screen.buttons.text.color}; background-color: ${screen.buttons.background}`"
            width="100%"
            @click="onAdd(digit)"
          >
            {{ digit }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          offset="4"
          cols="4"
          class="text-center"
        >
          <v-btn
            :style="`color: ${screen.buttons.text.color}; background-color: ${screen.buttons.background}`"
            width="100%"
            @click="onAdd(0)"
          >
            0
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
            :style="`color: ${screen.buttons.text.color}; background-color: ${screen.buttons.background}`"
            width="100%"
            @click="onBackspace"
          >
            C
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-2">
          <v-divider />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="6"
          class="text-center"
        >
          <v-btn
            color="error"
            @click="onCancel"
          >
            Отмена
          </v-btn>
        </v-col>
        <v-col
          cols="6"
          class="text-center"
        >
          <v-btn
            color="success"
            @click="onOk"
          >
            Ввод
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { configuration, ConfigurationTypeEnum } from "@/views/loyalty/models/justpay-configuration.model"

export default {
  name: 'ConfigurationSecondScreen',
  props: {
    configurationType: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
    },
    price: {
      type: Number,
    },
    screen: {
      type: Object,
      default: configuration.interface_description.first_screen
    },
    nomenclatures: {
      type: Array,
      // default: configuration.planogramm
    },
  },
  data: () => ({
    amountForPay: 0,
    anyAmount: "0",
    planogramm: null,
    priceOfGoods: 0,
  }),
  methods: {
    // add digit to sum
    onAdd (item) {
      // if (this.anyAmount[0] == 0) { this.anyAmount = this.anyAmount.substring(1) }
      this.anyAmount = this.anyAmount.replace(/^0+/g, '')
      this.anyAmount = this.anyAmount + item
    },
    // remove digit from sum
    onBackspace () {
      const length = this.anyAmount.length
      this.anyAmount = this.anyAmount.substring(0, length - 1)
    },
    onCancel () {
      this.$emit("cancel")
    },
    // ready to pay
    async onOk () {
      let items = []
      if (this.configurationType == ConfigurationTypeEnum.Donation) {
        this.amountForPay = this.anyAmount
        console.log('this.amountForPay', this.amountForPay)
        // const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
        console.log('nomenclature', nomenclature)
        items = [{
          name: nomenclature.name,
          count: 1,
          amount: this.amountForPay,
          price: this.amountForPay
        }]
      }
      if (this.configurationType == ConfigurationTypeEnum.Vitrina || this.configurationType == ConfigurationTypeEnum.Rele) {
        this.amountForPay = this.anyAmount * this.item.price
        console.log('this.amountForPay', this.amountForPay)
        // const nomenclature = this.nomenclatures.find(f => f.id === this.planogramm.nomenclature)
        // console.log('nomenclature', nomenclature)
        items = [{
          name: this.item.name, //  nomenclature.name,
          count: 1,
          amount: this.amountForPay,
          price: this.item.price,
          equipmentId: this.item.equipmentId,
          scenarioId: this.item.scenarioId
        }]
      }
      // await this.startToPay(items, this.planogramm.nomenclature)
      this.$emit('data', items)
    },
  }
}

</script>

<style scoped>

</style>
